<template>
  <svg
    aria-hidden="true"
    viewBox="0 0 24 24"
    class="sendArrow"
    width="1em"
    height="1em"
    fill="currentColor"
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M12 23.0469C10.5635 23.0469 9.49119 22.0756 9.49119 20.6999V11.8178L9.73398 7.69046L8.23679 9.73392L6.13264 12.1011C5.74824 12.5663 5.14125 12.8296 4.51406 12.8296C3.25966 12.8296 2.36945 11.9595 2.36945 10.7455C2.36945 10.0981 2.55153 9.61252 3.0371 9.10671L9.95654 1.86356C10.523 1.23637 11.1705 0.953125 12 0.953125C12.8094 0.953125 13.477 1.2566 14.0434 1.86356L20.9629 9.10671C21.4282 9.61252 21.6305 10.0981 21.6305 10.7455C21.6305 11.9595 20.7404 12.8296 19.4657 12.8296C18.8587 12.8296 18.2518 12.5663 17.8675 12.1011L15.7633 9.79461L14.2457 7.67023L14.5087 11.8178V20.6999C14.5087 22.0756 13.4163 23.0469 12 23.0469Z"
    />
  </svg>
</template>

<script>
export default { name: 'Send' };
</script>

<style scoped lang="scss" type="text/scss"></style>
